// import {
//   ApplicationConfig,
//   provideZoneChangeDetection,
//   importProvidersFrom,
// } from "@angular/core";
// import { provideRouter, withHashLocation } from "@angular/router";
// import { routes } from "./app.routes";
// import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
// import { provideHttpClient, withInterceptors } from "@angular/common/http";
// // import { fa_IR, provideNzI18n } from "ng-zorro-antd/i18n";
// import { registerLocaleData } from "@angular/common";
// import fa from "@angular/common/locales/fa";
// import { FormsModule } from "@angular/forms";
// import { environment } from "@env";
// import { BASE_URL } from "@core/base-url-token";
// import { AuthInterceptor } from "@core/auth-interceptor";
// // import { provideNzIcons } from "ng-zorro-antd/icon";
// // import * as AllIcons from "@ant-design/icons-angular/icons";
// // import { IconDefinition } from "@ant-design/icons-angular";

// registerLocaleData(fa);
// // const antDesignIcons = AllIcons as {
// //   [key: string]: IconDefinition;
// // };
// // const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
// //   (key) => antDesignIcons[key],
// // );
// export const appConfig: ApplicationConfig = {
//   providers: [
//     provideZoneChangeDetection({ eventCoalescing: true }),
//     provideRouter(routes, withHashLocation()),
//     provideAnimationsAsync(),
//     provideHttpClient(withInterceptors([AuthInterceptor])),
//     // provideNzI18n(fa_IR),
//     importProvidersFrom(FormsModule),
//     provideAnimationsAsync(),
//     provideHttpClient(),
//     // provideNzIcons(icons),
//     { provide: BASE_URL, useValue: environment.baseURL },
//   ],
// };

import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter, withHashLocation } from "@angular/router";
import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { registerLocaleData } from "@angular/common";
// import localeFa from "@angular/common/locales/fa";
// import fa from '@angular/common/locales/fa';
// @ts-ignore
// import fa from "@angular/common/locales/fa.js";

import { FormsModule } from "@angular/forms";
import { environment } from "@env";
import { BASE_URL } from "@core/base-url-token";
import { AuthInterceptor } from "@core/auth-interceptor";
import { MatSnackBarModule } from "@angular/material/snack-bar";

// registerLocaleData(fa); // فعال‌سازی زبان فارسی

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideAnimations(),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    importProvidersFrom(FormsModule, MatSnackBarModule),
    { provide: BASE_URL, useValue: environment.baseURL },
  ],
};
